export const IMAGES = {
  IC_INFO: "https://static.quizzop.com/newton/assets/logo-ic.png",
  QUIZZOP_LOGO: "https://static.quizzop.com/newton/assets/logo.png",
}
